import { FilterForm } from "./filter-form";

export function Controls() {
  return <FilterForm view="all" />;
}
